// before 20-5-2026

// import React, { useState } from 'react';
// import Modal from 'react-bootstrap/Modal';
// import SyncAltIcon from '@mui/icons-material/SyncAlt';
// import DeleteIcon from '@mui/icons-material/Delete';
// import Button from 'react-bootstrap/esm/Button';
// import { useDispatch } from 'react-redux';
// import { Notify } from '../../Utility/Notify';
// import {
//   DeleteOneCommunicationData,
//   UpdateOneCommunicationData,
// } from '../../Redux/Actions/CommunicationWay_Action';
// import { Link } from 'react-router-dom';
// import { useTheme } from '@mui/material/styles';

// export const CommunicationwayActions = ({ communication }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const dispatch = useDispatch();

//   const [show, setShow] = useState(false);
//   const [loading, setloading] = useState(true);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const deleteCommunicationway = async (e) => {
//     setloading(true);
//     // await dispatch(DeleteOneCommunicationData(communication._id))
//     await dispatch(
//       UpdateOneCommunicationData(communication._id, {
//         iscommunicationwayactivate: 'false',
//       }),
//     );
//     Notify('success', 'Deleted Successfuly', 'success');
//     setTimeout(() => {
//       window.location.reload();
//     }, 1500);
//     setloading(false);
//   };

//   return (
//     <div style={{ textAlign: 'center' }}>
//       {/* <Modal style={{zIndex:'40000'}} show={show} onHide={handleClose}>
//     <Modal.Header closeButton style={{color: mode === "dark" ? "#90caf9" : "#0F7687",backgroundColor: mode === "dark" ? "#252525" : "#f5f5f5"}}
//     >
//       <Modal.Title>Modal Delete</Modal.Title>
//     </Modal.Header>
//     <Modal.Body style={{color: mode === "dark" ? "#90caf9" : "#0F7687",backgroundColor: mode === "dark" ? "#252525" : "#f5f5f5"}}    >Do you Want To Delete This Regions ?</Modal.Body>
//     <Modal.Footer style={{color: mode === "dark" ? "#90caf9" : "#0F7687",backgroundColor: mode === "dark" ? "#252525" : "#f5f5f5"}}    >
//       <Button variant="secondary" onClick={handleClose}>
//         Close
//       </Button>
//       <Button variant="primary" onClick={deleteCommunicationway}>
//         Yes , I Want To Delete regions
//       </Button>
//     </Modal.Footer>
//   </Modal> */}

//       <Modal style={{ zIndex: '40000' }} show={show} onHide={handleClose} centered>
//         <div
//           style={{
//             padding: '10px',
//             borderRadius: '10px',
//             backgroundColor: mode === 'dark' ? '#252525' : '#ffffff',
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             textAlign: 'center',
//           }}
//         >
//           {/* أيقونة الحذف */}
//           <div style={{ padding: '0px 0' }}>
//             <div style={{ padding: '0px 0' }}>
//               <svg
//                 width="455"
//                 height="260"
//                 viewBox="0 0 662 260"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <rect width="662" height="260" rx="8" fill="#666" fillOpacity="0.1" />
//                 <mask
//                   id="mask0"
//                   style={{ maskType: 'luminance' }}
//                   maskUnits="userSpaceOnUse"
//                   x="260"
//                   y="36"
//                   width="143"
//                   height="143"
//                 >
//                   <path d="M402.695 36H260.367V178.328H402.695V36Z" fill="white" />
//                 </mask>
//                 <g mask="url(#mask0)">
//                   <mask
//                     id="mask1"
//                     style={{ maskType: 'luminance' }}
//                     maskUnits="userSpaceOnUse"
//                     x="266"
//                     y="54"
//                     width="51"
//                     height="51"
//                   >
//                     <path d="M316.688 54.918H266.873V104.733H316.688V54.918Z" fill="white" />
//                   </mask>
//                   <g mask="url(#mask1)">
//                     <path
//                       d="M282.873 69.459L300.682 69.4862C300.682 69.4862 300.684 72.7771 300.686 75.7181"
//                       stroke="#666"
//                       strokeWidth="2.19844"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                     <path
//                       d="M284.565 73.6465C282.608 71.6893 280.355 69.4368 280.355 69.4368C280.355 69.4368 282.95 66.8425 285.041 64.7511"
//                       stroke="#326677"
//                       strokeWidth="2.19844"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </g>
//                   <path
//                     d="M322.418 154.201L291.417 141.042C289.304 140.145 288.318 137.704 289.215 135.591L302.374 104.59C303.271 102.477 305.711 101.491 307.825 102.388L338.825 115.547C340.939 116.444 341.925 118.885 341.028 120.998L327.869 151.999C326.972 154.112 324.531 155.098 322.418 154.201Z"
//                     fill="#78E75A"
//                   />
//                   <path
//                     d="M317.364 155.105L293.14 127.238C291.489 125.339 291.69 122.46 293.59 120.808L321.457 96.584C323.356 94.9326 326.235 95.1339 327.887 97.0337L352.111 124.9C353.762 126.8 353.561 129.679 351.661 131.331L323.795 155.555C321.895 157.206 319.016 157.005 317.364 155.105Z"
//                     fill="#57B3FE"
//                   />
//                   <path
//                     d="M344.969 145.335L324.675 124.32C323.291 122.888 323.331 120.605 324.764 119.221L345.779 98.927C347.212 97.5435 349.495 97.5833 350.878 99.016L371.172 120.031C372.556 121.464 372.516 123.747 371.083 125.13L350.068 145.424C348.635 146.808 346.352 146.768 344.969 145.335Z"
//                     fill="#F45170"
//                   />
//                   <path
//                     d="M362.894 174.148H296.281C292.837 174.148 289.99 171.466 289.784 168.029L285.537 97.1136C285.359 94.1475 287.717 91.6445 290.688 91.6445H368.487C371.458 91.6445 373.816 94.1475 373.638 97.1136L369.391 168.029C369.185 171.466 366.337 174.148 362.894 174.148Z"
//                     fill="#C9CEE2"
//                   />
//                   <path
//                     d="M309.501 163.473C307.776 163.473 306.311 162.149 306.167 160.398L301.636 105.235C301.485 103.392 302.857 101.774 304.701 101.623C306.527 101.483 308.161 102.842 308.312 104.687L312.843 159.851C312.994 161.693 311.622 163.311 309.779 163.462C309.686 163.47 309.593 163.473 309.501 163.473Z"
//                     fill="#9EA9C9"
//                   />
//                   <path
//                     d="M329.589 163.475C327.74 163.475 326.24 161.976 326.24 160.126V104.962C326.24 103.112 327.74 101.613 329.589 101.613C331.439 101.613 332.939 103.112 332.939 104.962V160.126C332.939 161.976 331.439 163.475 329.589 163.475Z"
//                     fill="#9EA9C9"
//                   />
//                   <path
//                     d="M349.676 163.473C349.584 163.473 349.491 163.469 349.398 163.462C347.554 163.311 346.182 161.693 346.334 159.85L350.864 104.687C351.015 102.842 352.625 101.486 354.476 101.623C356.319 101.774 357.691 103.392 357.54 105.235L353.009 160.398C352.865 162.149 351.401 163.473 349.676 163.473Z"
//                     fill="#9EA9C9"
//                   />
//                   <path
//                     d="M380.51 99.3223L309.503 49.0784C307.297 47.5175 306.774 44.4644 308.335 42.2586C309.895 40.0528 312.949 39.5296 315.155 41.0905L386.162 91.3344C388.368 92.8953 388.89 95.9487 387.33 98.1544C385.769 100.36 382.716 100.883 380.51 99.3223Z"
//                     fill="#4C5C75"
//                   />
//                   <path
//                     d="M363.3 75.1553L338.02 57.2671L339.682 54.9181C341.469 52.3918 344.966 51.793 347.492 53.5805L363.625 64.9959C366.151 66.7833 366.75 70.2803 364.962 72.8064L363.3 75.1553Z"
//                     fill="#C9CEE2"
//                   />
//                 </g>
//               </svg>
//             </div>
//           </div>

//           {/* العنوان */}
//           <h5 style={{ fontWeight: 'bold', color: '#333' }}>Are you sure to delete ...?</h5>

//           {/* النص التوضيحي */}
//           <p style={{ color: '#888', marginTop: '10px' }}>This item will be deleted from Area..</p>

//           {/* الأزرار */}
//           <div className="d-flex justify-content-center gap-3 mt-4">
//             <Button
//               // variant="outline-secondary"
//               onClick={handleClose}
//               style={{ minWidth: '120px', background: '#fff', color: '#102dff' }}
//             >
//               No
//             </Button>
//             <Button
//               // variant="danger"
//               onClick={deleteCommunicationway}
//               style={{ minWidth: '120px', background: '#102dff' }}
//             >
//               Yes , Delete
//             </Button>
//           </div>
//         </div>
//       </Modal>

//       <div className="d-flex justify-content-center">
//         <Link
//           to={`/UpdateCommunicationway/${communication?._id}`}
//           style={{ textDecoration: 'none' }}
//         >
//           {/* <div  className='public-color btn btn-primary mx-2 updateclientbtn' style={{border:'none'}}><SyncAltIcon/> Update</div> */}
//           <SyncAltIcon
//             className="btnhover"
//             style={{ color: mode === 'dark' ? '#ccc' : '#102dff' }}
//           />
//         </Link>
//         {/* <div onClick={handleShow}  className='deletebtn btn btn-primary mx-2 updateclientbtn' style={{background:'#0F7687',border:'none'}} ><DeleteIcon/> Delete</div> */}
//         <span onClick={handleShow} className="mx-1" style={{ cursor: 'pointer' }}>
//           <DeleteIcon className="btnhover" style={{ color: 'red' }} />
//         </span>
//       </div>
//     </div>
//   );
// };













// 20-5-2026
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Notify } from '../../Utility/Notify';
import { UpdateOneCommunicationData } from '../../Redux/Actions/CommunicationWay_Action';
import { useTheme } from '@mui/material/styles';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconEdit = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

const IconTrash = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </svg>
);

const IconWarning = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

const IconClose = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const IconComm = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

/* ─── CSS (injected once) ────────────────────────────────────────────────── */
const CSS = `
  .cw-btn {
    display: inline-flex; align-items: center; justify-content: center;
    width: 32px; height: 32px; border-radius: 8px;
    border: 1px solid transparent; cursor: pointer;
    background: transparent;
    transition: background 0.18s, border-color 0.18s, color 0.18s, transform 0.15s;
    color: #7B829A; text-decoration: none;
  }
  .cw-btn:hover { transform: translateY(-1px); }
  .cw-btn.edit  { border-color: #E8EAF0; background: #F7F8FC; color: #1A3ECF; }
  .cw-btn.edit:hover { background: #EEF1FF; border-color: #1A3ECF; }
  .cw-btn.del   { border-color: #FFE4E4; background: #FFF5F5; color: #E53935; }
  .cw-btn.del:hover { background: #FFE4E4; border-color: #E53935; }

  .cw-overlay {
    position: fixed; inset: 0; z-index: 999999;
    display: flex; align-items: center; justify-content: center;
    background: rgba(0,0,0,0.75);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    animation: cw-fadein 0.22s ease-out both;
  }
  @keyframes cw-fadein { from { opacity: 0; } to { opacity: 1; } }

  .cw-card {
    width: 100%; max-width: 500px; margin: 0 20px;
    border-radius: 28px; padding: 40px 32px 36px;
    background: #ffffff;
    box-shadow: 0 40px 100px rgba(0,0,0,0.35);
    position: relative;
    animation: cw-slidein 0.28s cubic-bezier(0.34,1.2,0.64,1) both;
  }
  .cw-card.dark-m { background: linear-gradient(135deg,#1a1f2e 0%,#141829 100%); color: #E4E8F5; }
  @keyframes cw-slidein {
    from { opacity: 0; transform: translateY(28px) scale(0.95); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }

  .cw-close {
    position: absolute; top: 18px; right: 18px;
    width: 36px; height: 36px; border-radius: 12px;
    border: 1px solid #E8EAF0; background: #F7F8FC;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    color: #7B829A; transition: all 0.2s;
  }
  .cw-close:hover { background: #FFE4E4; border-color: #E53935; color: #E53935; transform: scale(1.05); }
  .dark-m .cw-close { background: #252D4A; border-color: #3A4570; color: #9099c0; }
  .dark-m .cw-close:hover { background: #4a2525; border-color: #E53935; color: #E53935; }

  .cw-icon {
    width: 84px; height: 84px; border-radius: 50%;
    background: linear-gradient(135deg,#FFF3F3,#FFE4E4);
    border: 2px solid #FFBDBD;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 22px; color: #E53935;
    box-shadow: 0 8px 24px rgba(229,57,53,0.18);
  }
  .dark-m .cw-icon { background: linear-gradient(135deg,#2a1a1a,#3a2525); border-color: #5a3535; }

  .cw-title {
    font-family: 'DM Sans', sans-serif;
    font-size: 22px; font-weight: 700;
    color: #1C2340; text-align: center;
    margin: 0 0 10px; letter-spacing: -0.3px;
  }
  .dark-m .cw-title { color: #E4E8F5; }

  .cw-sub {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px; color: #7B829A;
    text-align: center; margin: 0 0 28px; line-height: 1.65;
  }

  .cw-badge {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 7px 16px; border-radius: 40px;
    background: #F0F4FF; border: 1px solid #D6E0FF;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px; font-weight: 600; color: #1A3ECF;
    margin-bottom: 28px;
  }
  .dark-m .cw-badge { background: #252D4A; border-color: #3A4570; color: #7DA4FF; }

  .cw-actions { display: flex; gap: 12px; }

  .cw-cancel {
    flex: 1; padding: 14px 0; border-radius: 14px;
    border: 1.5px solid #E8EAF0; background: #F7F8FC;
    font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 600;
    color: #1C2340; cursor: pointer; transition: all 0.2s;
  }
  .cw-cancel:hover { background: #EBEDF5; border-color: #C8CADC; transform: translateY(-1px); }
  .dark-m .cw-cancel { background: #252D4A; border-color: #3A4570; color: #E4E8F5; }
  .dark-m .cw-cancel:hover { background: #2E3860; }

  .cw-confirm {
    flex: 1; padding: 14px 0; border-radius: 14px; border: none;
    background: linear-gradient(135deg,#E53935,#C62828);
    font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 700;
    color: #fff; cursor: pointer; transition: all 0.2s;
    box-shadow: 0 6px 20px rgba(229,57,53,0.3);
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }
  .cw-confirm:hover { background: linear-gradient(135deg,#EF5350,#D32F2F); box-shadow: 0 8px 28px rgba(229,57,53,0.4); transform: translateY(-2px); }
  .cw-confirm:disabled { background: #E8EAF0; color: #B0B5C9; box-shadow: none; transform: none; cursor: not-allowed; }

  .cw-spin {
    width: 17px; height: 17px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: #fff; border-radius: 50%;
    animation: cw-spin 0.7s linear infinite;
  }
  @keyframes cw-spin { to { transform: rotate(360deg); } }

  @media (max-width: 560px) {
    .cw-card { padding: 30px 20px 26px; border-radius: 20px; }
    .cw-title { font-size: 19px; }
    .cw-icon  { width: 68px; height: 68px; }
  }
`;

let injected = false;
const injectCSS = () => {
  if (injected) return;
  injected = true;
  const el = document.createElement('style');
  el.innerHTML = CSS;
  document.head.appendChild(el);
};

/* ─── Delete Modal via Portal ────────────────────────────────────────────── */
const DeleteModal = ({ isDark, communicationName, onClose, onConfirm, loading }) =>
  createPortal(
    <div
      className="cw-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className={`cw-card ${isDark ? 'dark-m' : ''}`}>

        <button className="cw-close" onClick={onClose}><IconClose /></button>

        <div className="cw-icon"><IconWarning /></div>

        <p className="cw-title">Delete Communication Way?</p>
        <p className="cw-sub">
          This action will deactivate the communication way.<br />
          You can restore it later from the admin panel.
        </p>

        {communicationName && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <span className="cw-badge">
              <IconComm />
              {communicationName}
            </span>
          </div>
        )}

        <div className="cw-actions">
          <button className="cw-cancel" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="cw-confirm" onClick={onConfirm} disabled={loading}>
            {loading
              ? <><div className="cw-spin" />Deleting…</>
              : <><IconTrash />Delete</>}
          </button>
        </div>

      </div>
    </div>,
    document.body
  );

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const CommunicationwayActions = ({ communication }) => {
  injectCSS();

  const theme   = useTheme();
  const isDark  = theme.palette.mode === 'dark';
  const dispatch = useDispatch();

  const [show,    setShow]    = useState(false);
  const [loading, setLoading] = useState(false);

  const deleteCommunicationway = async () => {
    setLoading(true);
    await dispatch(
      UpdateOneCommunicationData(communication._id, {
        iscommunicationwayactivate: 'false',
      })
    );
    setLoading(false);
    setShow(false);
    Notify('success', 'Deleted Successfully', 'success');
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <Link
          to={`/UpdateCommunicationway/${communication?._id}`}
          className="cw-btn edit"
          title="Edit communication way"
        >
          <IconEdit />
        </Link>
        <button
          className="cw-btn del"
          title="Delete communication way"
          onClick={() => setShow(true)}
        >
          <IconTrash />
        </button>
      </div>

      {show && (
        <DeleteModal
          isDark={isDark}
          communicationName={communication?.name}
          onClose={() => setShow(false)}
          onConfirm={deleteCommunicationway}
          loading={loading}
        />
      )}
    </>
  );
};
